import React from 'react';
import styled from 'styled-components';
import { BRANDING } from '../config/branding';
import { SOCIAL_LINKS } from '../utils/constants';

const Foot = styled.footer`
  background: linear-gradient(145deg, #090909 0%, #111111 100%);
  color: #ffffff;
  padding: 3rem 2rem;
  font-family: 'Roboto', sans-serif;
`;

const Inner = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 2fr;
  gap: 2rem;
  margin-bottom: 2rem;
  @media (max-width: 900px) { grid-template-columns: 1fr 1fr; }
  @media (max-width: 520px) { grid-template-columns: 1fr; }
`;

const ColTitle = styled.h5`
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 1rem;
  color: #e8d28a;
`;

const ColText = styled.p`
  color: rgba(255,255,255,.82);
  font-size: 0.95rem;
  line-height: 1.65;
  margin: 0 0 1rem;
`;

const ColLink = styled.a`
  display: block;
  color: #e8d28a;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 0.45rem;
  &:hover { color: #ffffff; }
`;

const SocialRow = styled.div`
  display: flex;
  gap: 0.65rem;
  margin-top: 0.6rem;
`;

const SocialBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px; height: 38px;
  border-radius: 50%;
  background: rgba(196,152,14,.15);
  color: #e8d28a;
  font-size: 1.05rem;
  text-decoration: none;
  &:hover { background: rgba(196,152,14,.28); color: #fff; }
`;

const BottomBar = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(255,255,255,.12);
  text-align: center;
  font-size: 0.9rem;
  color: rgba(255,255,255,.55);
`;

const BottomLink = styled.a`
  color: #e8d28a;
  text-decoration: none;
  &:hover { color: #ffffff; }
`;

const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.7rem;

  img {
    display: block;
    object-fit: contain;
  }

  .logo {
    height: 32px;
    width: auto;
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const Footer = () => (
  <Foot>
    <Inner>
      <div>
        <BrandRow>
          <img className="logo" src={BRANDING.logoPath} alt={BRANDING.appName} />
        </BrandRow>
        <ColTitle>About {BRANDING.appName}</ColTitle>
        <ColText>
          Empower your sports betting journey with {BRANDING.appName} — your comprehensive toolkit for serious bettors.
          Our algorithm-generated predictions give you a clearer edge on every game.
        </ColText>
      </div>
      <div>
        <ColTitle>Quick Links</ColTitle>
        <ColLink href="/packages">Get Access</ColLink>
        <ColLink href="/system-docs">System Docs</ColLink>
        <ColLink href="/login">Login</ColLink>
        <ColLink href="/contact">Support</ColLink>
        <ColLink href="/settings">Account</ColLink>
      </div>
      <div>
        <ColTitle>Explore</ColTitle>
        <ColLink href="/">Home</ColLink>
        <ColLink href="/system-docs">System Docs</ColLink>
        <ColLink href="/packages">Packages</ColLink>
        <ColLink href="/login">Log In</ColLink>
      </div>
      <div>
        <ColTitle>Follow Us</ColTitle>
        <ColText>Stay updated via our social channels.</ColText>
        <SocialRow>
          <SocialBtn href={SOCIAL_LINKS.x} target="_blank" rel="noopener noreferrer" aria-label="Follow on X">
            <i className="fab fa-x-twitter" />
          </SocialBtn>
          <SocialBtn href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Follow on Instagram">
            <i className="fab fa-instagram" />
          </SocialBtn>
          <SocialBtn href={SOCIAL_LINKS.winible} target="_blank" rel="noopener noreferrer" aria-label="Follow on Winible">
            <i className="fas fa-chart-line" />
          </SocialBtn>
        </SocialRow>
      </div>
    </Inner>
    <BottomBar>
      &copy; {new Date().getFullYear()} {BRANDING.companyName}. All Rights Reserved.
      {' · '}
      <BottomLink href={BRANDING.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </BottomLink>
    </BottomBar>
  </Foot>
);

export default Footer;
